/** Recarga de la página como objeto, para poder observarla en pruebas (jsdom no recarga). */
export const pagina = { recargar: () => window.location.reload() }
